module.exports = __webpack_public_path__ + "assets/images/arrow-outbound-orange.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/arrow-outbound-orange.png
// module id = 396
// module chunks = 1